import React from 'react';
import Style from './style.module.css';

const Spinner = () => {
  return (
    <div className={Style.container}>
      <div className={Style.spinner}></div>
    </div>
  );
};

export default Spinner;
